import { render, staticRenderFns } from "./IssueDate.vue?vue&type=template&id=499b980c&scoped=true&"
import script from "./IssueDate.vue?vue&type=script&lang=js&"
export * from "./IssueDate.vue?vue&type=script&lang=js&"
import style0 from "./IssueDate.vue?vue&type=style&index=0&id=499b980c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b980c",
  null
  
)

export default component.exports